module.exports = __webpack_public_path__ + "img/sdg13_jp.1282c68b.png";